import { Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useUIStore } from '@/stores/ui';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { QuickSearch } from './QuickSearch';
import { LogViewer } from '@/components/features/LogViewer';

export function Layout() {
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <Sidebar />

      <div
        className={cn(
          'flex flex-col transition-[margin] duration-300 ease-in-out',
          sidebarCollapsed ? 'ml-14' : 'ml-64'
        )}
      >
        <Header />

        <main className="mx-auto w-full max-w-7xl flex-1 p-6">
          <Outlet />
        </main>
      </div>

      <QuickSearch />
      <LogViewer />
    </div>
  );
}
